import { produce } from 'immer';
import { SET_SELECTED_GROUPING_LEVEL_FILTERS } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {
  COMMIT_SELECTIONS,
  NEW_GROUPING_LEVELS_FILTER,
  REMOVE_GROUPING_LEVELS_FILTER,
  SET_GROUPING_LEVELS_FILTER_INCLUDE_EXCLUDE,
  SET_IS_DEFAULT_BENCHMARK,
  SET_IS_LOOKTHRU,
  SET_MIN_ACC_WEIGHT,
  SET_MIN_BENCH_WEIGHT,
  SET_SELECTED_ACCOUNT_ENTITY_ID,
  SET_SELECTED_AS_OF_DATE,
  SET_SELECTED_BENCHMARK_ENTITY_ID,
  SET_SELECTED_GROUPING_LEVELS,
  SET_SYMBOLIC_DATE,
  SET_GROUPING_LEVELS_FILTER_LEVEL,
  SET_GROUPING_LEVELS_FILTER_LEVEL_KEYS,
  SET_SECURITY_LABEL,
  SET_GROUPING_LEVELS_FILTER_REWEIGHT,
  SET_SCENARIOS_VALUE,
  SET_BENCHMARK_SCENARIOS_VALUE,
  SET_SIDE_BY_SIDE,
  SET_DISABLE_BMARK_WORKSPACE
} from './actions';

const defaultGroupingLevelFilter = {
  includeExclude: 'INCLUDE',
  level: null,
  levelKeys: null,
  reweight: false,
};

const defaultSelections = {
  asOfDate: null,
  symbolicDate: null,
  accountEntityId: null,
  benchmarkEntityId: null,
  groupingLevels: null,
  groupingLevelsFilters: [],
  groupingLevelsFiltersReweight: false,
  isLookthru: true,
  isDefaultBenchmark: true,
  minBenchWeight: .01,
  minAccWeight: null,
  securityLabel: null,
  scenario: null,
  benchmarkScenario: null,
  sideBySide: false,
  isDisableBenchmarkWorkspace: true
};

const defaultState = {
  [SelectionState.COMMITTED]: { ...defaultSelections },
  [SelectionState.UNCOMMITTED]: { ...defaultSelections },
  covarianceOptions: [
    {
      label: 'HIST',
      value: 'HIST',
    },
    {
      label: 'REGIME',
      value: 'SHORT',
    },
  ],
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_SELECTED_AS_OF_DATE: {
      state[SelectionState.UNCOMMITTED].asOfDate = action.asOfDate;
      break;
    }
    case SET_SYMBOLIC_DATE: {
      state[SelectionState.UNCOMMITTED].symbolicDate = action.symbolicDate;
      break;
    }
    case SET_SELECTED_ACCOUNT_ENTITY_ID: {
      state[SelectionState.UNCOMMITTED].accountEntityId = action.accountEntityId;
      break;
    }
    case SET_SELECTED_BENCHMARK_ENTITY_ID: {
      state[SelectionState.UNCOMMITTED].benchmarkEntityId = action.benchmarkEntityId;
      break;
    }
    case SET_SELECTED_GROUPING_LEVELS: {
      state[SelectionState.UNCOMMITTED].groupingLevels = action.groupingLevels;
      break;
    }
    case SET_SELECTED_GROUPING_LEVEL_FILTERS: {
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters = action.payload.groupingLevelsFilters;
      break;
    }
    case NEW_GROUPING_LEVELS_FILTER: {
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters.push(defaultGroupingLevelFilter);
      break;
    }
    case REMOVE_GROUPING_LEVELS_FILTER: {
      const { idx } = action.payload;
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters.splice(idx, 1);
      break;
    }
    case SET_GROUPING_LEVELS_FILTER_INCLUDE_EXCLUDE: {
      const { idx, includeExclude } = action.payload;
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters[idx].includeExclude = includeExclude;
      break;
    }
    case SET_GROUPING_LEVELS_FILTER_LEVEL: {
      const { idx, level } = action.payload;
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters[idx].level = level;
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters[idx].levelKeys = defaultGroupingLevelFilter.levelKeys;
      break;
    }
    case SET_GROUPING_LEVELS_FILTER_LEVEL_KEYS: {
      const { idx, levelKeys } = action.payload;
      state[SelectionState.UNCOMMITTED].groupingLevelsFilters[idx].levelKeys = levelKeys;
      break;
    }

    case SET_GROUPING_LEVELS_FILTER_REWEIGHT: {
      const { reweight } = action.payload;
      state[SelectionState.UNCOMMITTED].groupingLevelsFiltersReweight = reweight;
      break;
    }
    case SET_SECURITY_LABEL: {
      state[SelectionState.UNCOMMITTED].securityLabel = action.securityLabel;
      break;
    }
    case SET_IS_LOOKTHRU: {
      state[SelectionState.UNCOMMITTED].isLookthru = action.isLookthru;
      break;
    }
    case SET_IS_DEFAULT_BENCHMARK: {
      state[SelectionState.UNCOMMITTED].isDefaultBenchmark = action.isDefaultBenchmark;
      break;
    }
    case SET_MIN_BENCH_WEIGHT: {
      state[SelectionState.UNCOMMITTED].minBenchWeight = action.minBenchWeight;
      break;
    }
    case SET_MIN_ACC_WEIGHT: {
      state[SelectionState.UNCOMMITTED].minAccWeight = action.minAccWeight;
      break;
    }
    case COMMIT_SELECTIONS: {
      state[SelectionState.COMMITTED] = state[SelectionState.UNCOMMITTED];
      break;
    }

    case SET_SCENARIOS_VALUE: {
      state[SelectionState.UNCOMMITTED].scenario = action.value;
      if (!action.value) {
        state[SelectionState.UNCOMMITTED].sideBySide = false;
      }
      break;
    }
    case SET_BENCHMARK_SCENARIOS_VALUE: {
      state[SelectionState.UNCOMMITTED].benchmarkScenario = action.value;
      break;
    }
    case SET_SIDE_BY_SIDE: {
      state[SelectionState.UNCOMMITTED].sideBySide = action.value;
      break;
    }
    case SET_DISABLE_BMARK_WORKSPACE: {
      state[SelectionState.UNCOMMITTED].isDisableBenchmarkWorkspace = action.value;
      break;
    }

    default:
      return state;
  }
});
